module.exports = {
      id: "photographer-usage",
      viewBox: "0 0 24 24",
      url: "/" + "sprite-d3510a915c790cce9510dd41eb326371.svg#photographer",
      toString: function () {
        return this.url;
      }
    }